// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionButtonController from "./action_button_controller"
application.register("action-button", ActionButtonController)

import AppController from "./app_controller"
application.register("app", AppController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

